import * as globals from '@wandb/common/css/globals.styles';
import {WBIcon} from '@wandb/ui';
import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SelectionItemContainer = styled.div<{
  $selected?: boolean;
  $disabled?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid ${p => (p.$selected ? globals.primary : globals.gray50)};
  border-radius: 4px;
  background: ${p => (p.$selected ? globals.white : globals.gray50)};
  padding: calc(${globals.spu} * 2);
  margin: 8px;
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
`;

export const IconAndTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ItemLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
`;

export const ItemDescription = styled.div`
  font-size: ${globals.fontSizeStandard};
  line-height: 24px;
`;

export const ItemLabelAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const CheckMarkIcon = styled(WBIcon)<{$selected?: boolean}>`
  margin-left: calc(${globals.spu} * 2);
  color: ${p => (p.$selected ? globals.primary : globals.gray300)};
  font-size: 32px;
  font-weight: 800;
`;

export const IconContainer = styled.div<{$selected?: boolean}>`
  width: 64px !important;
  height: 64px !important;
  flex-shrink: 0;

  /* primary background, 8% opacity */
  background: ${p =>
    p.$selected ? `rgba(46, 120, 199, 0.08)` : globals.gray300};
  border-radius: 200px;

  /* Inside auto layout */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: calc(${globals.spu} * 2);
`;

export const Icon = styled(WBIcon)<{$selected?: boolean}>`
  font-size: 32px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 3px 8px 5px;
  margin-left: 16px;

  font-size: 16px;
  font-weight: 400;

  /* gold-transparent */

  background: rgba(255, 201, 51, 0.2);
  border-radius: 3px;

  /* gold-dark */
  color: #f59b14;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
`;
